import { memoize } from 'lodash';

// Fix error where calling .json() more than once gives 'body locked error'
//
// Although could be used in all places where we call .json() it would not provide any benefit
// when returning a non failure response so just naming 'getErrorJson'.
const getErrorJson = memoize(
  (response: Response): Promise<any> => response.clone().json(),
);

export { getErrorJson };
